<script setup>
const { params } = useRoute()
const { Settings } = useSettings()
const config = useRuntimeConfig()

const i18n = useI18n()

const { data: post, pending } = await useFetch(`/api/post/detail/${params?.id}`, { key: params?.id })

if (!post.value) {
  showError({ statusCode: 404, statusMessage: `This page does not exists` })
}

const date = computed(() => new Date(post?.value.date).toLocaleDateString(i18n.locale.value, {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric' }))

const pageTitle = `${Settings?.value.name} - ${post?.value?.title}`
useHead({
  title: pageTitle,
  meta: [
    { property: 'og:title', content: pageTitle },
    { property: 'og:url', content: config.public.baseUrl + `/p/${params?.id}` },
    { property: 'og:image', content: config.public.baseUrl + '/media/logo' }
  ]
})

const image = computed(() => '/media/' + (post?.value.image ?? post?.value.source?.image ?? 'fallbackImage.png')?.replace(/.jpg$/, '.webp'))
</script>

<template>
<v-container
  v-if="!pending"
  :loading="pending"
  class="details"
>
  <picture class="overflow-hidden">
    <img
      class="w-100"
      :src="image"
      loading="lazy"
    >
  </picture>
  <a
    :href="post.URL"
    class="text-h6"
  ><h1>{{ post?.title }}</h1></a>
  <nuxt-link :to="`/s/${post.source?.id}`">{{ post.source?.name || post.source?.link }}</nuxt-link> -
  {{ date }}
  <div
    v-if="post?.tags?.length"
    class="mb-1"
  >
    <v-chip
      v-for="tag in post.tags"
      :key="tag.id"
      label
      :to="`/tag/${tag.id}`"
      color="primary"
      size="small"
      class="mr-1 mt-1"
    >
      {{ tag.name }}
    </v-chip>
  </div>

  <div
    class="content ma-6"
    v-html="post?.content"
  />
</v-container>
</template>

<style>
.details a.title {
  color: rgba(var(--v-theme-primary));
  text-decoration: none;
}

.details img {
  max-height: 300px;
  object-fit: cover;
  width: 100%;
}

.details .content  img {
  max-width: 100%;
}
</style>
